import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

type CalendarWrapperProps = {
  $isMobile?: boolean
}
export const CalendarWrapper = styled.div<CalendarWrapperProps>`
  display: grid;
  grid-template-columns: ${props => !props.$isMobile ? `${toRem(280)} auto` : 'auto'};
  min-width: 100%;
  height: calc(100dvh - ${props => props.$isMobile ? toRem(110) : toRem(41)});
  margin: 0 ${toRem(-16)};
  overflow: clip auto;

  ${props => !props.$isMobile && css`
    margin: ${toRem(-16)} ${toRem(-16)} 0;
  `}
`

export const CalendarCalendarHead = styled.div`
  display: flex;
  gap: ${toRem(12)};
  justify-content: space-between;
  padding: ${toRem(16)};

  --button-ghost-accent-label-color-default: ${COLORS.FG.DEFAULT};

  .button--ghost {
    text-transform: capitalize;
    --button-m-padding-left: 0;
    --button-m-padding-right: 0;
  }
`

export const CalendarCalendarTitle = styled.h2`
  display: flex;
  gap: ${toRem(8)};
  font-weight: 500;
  font-size: ${toRem(22)};

  span {
    text-transform: capitalize;
  }

  i {
    color: ${COLORS.FG.MUTED};
  }
`

export const CalendarCalendarActions = styled.div`
  display: flex;
  gap: ${toRem(8)};

  --button-m-padding-left: ${toRem(6)};
  --button-m-padding-right: ${toRem(6)};
  --input-primary-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --input-m-border-width: 0;

  .input {
    min-width: ${toRem(100)};
    width: ${toRem(100)};
  }
`

export const DrawerDateWrapper = styled.div`
  display: flex;
  justify-content:center;align-items: center;
  padding: ${toRem(16)};
`

export const DrawerHivesWrapper = styled.div`
  padding: ${toRem(16)};

  h3 {
    text-align: center;
    font-weight: 500;
    font-size: ${toRem(16)};
    line-height: ${20 / 16};
    &:not(:last-child) {margin-bottom: ${toRem(16)};}
  }
`

export const CaletdatFluidToTodayButton = styled.button`
  position: fixed;
  left: 50%;
  translate: -50% 0;
  bottom: ${toRem(72)};
  background-color: ${COLORS.BG.ELEVATED.XL};
  font-size: ${toRem(14)};
  line-height: ${20 / 14};
  padding: ${toRem(8)} ${toRem(12)};
  border-radius: ${toRem(8)};
  z-index: 2;

  box-shadow: 0px 32px 32px 0px ${COLORS.NEUTRAL.CONTAINER_SOFT}, 0px 0px 32px 0px ${COLORS.NEUTRAL.CONTAINER_MUTED};

`